import {action, observable} from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

// 模块管理
export default class moduleState extends baseState {
  // 模块管理列表
  @observable list = {};
  @action
  setList(data) {
    this.list = data;
  }
  getList = (data) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MODULE.LIST,
      setState: this.setList,
      method: 'get',
      data
    });
  };
  // 模块管理详情
  @observable detail = {};
  @action
  setDetail(data) {
    this.detail = data;
  }
  getDetail = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MODULE.DETAIL + id,
      setState: this.setDetail,
      method: 'get',
    });
  };

  insert = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.MODULE.INSERT,
      data,
    });
  };

  update = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.MODULE.UPDATE,
      data,
    });
  };

  delete = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MODULE.DELETE + id,
    });
  };

}
